import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BdAppEnvironmentService } from '@bindoc-projects/platform-lib/data';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BdPermissionsUsersStore } from '../store/users/users.store';
import { BdGraphApiUser } from './user.model';
import { BdUsersCacheService } from './users-cache.service';
import { ApiEndpointKey } from '@bindoc-projects/app-config-domain-lib';

@Injectable({
  providedIn: 'root',
})
export class BdPermissionsUsersService {
  private _cacheService = inject(BdUsersCacheService);
  private _httpClient = inject(HttpClient);
  private _environmentService = inject(BdAppEnvironmentService);

  private _store: BdPermissionsUsersStore;

  constructor() {
    this._store = new BdPermissionsUsersStore(this._environmentService.load(ApiEndpointKey.BD_PERMISSION_RESOURCE_URL));
  }

  public getById(id: string): Observable<BdGraphApiUser | null> {
    let user$;
    const cached = this._cacheService.get(id);

    if (cached) {
      user$ = of(cached);
    } else {
      const url = this._store.byId(id);

      user$ = this._httpClient.get<BdGraphApiUser | null>(url).pipe(
        tap((user) => {
          if (user) {
            this._cacheService.set(user);
          }
        }),
      );
    }

    return user$;
  }
}
